module.exports = __webpack_public_path__ + "media/stop-17.d177250f.mp3";